module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBlack.65eb9ee.woff2";